import React from 'react';
import {
  useLocation,
  useHistory,
  useNavigate,
  useParams,
} from 'react-router-dom';

import Sidebar from '../../layouts/Sidebar';
import Loading from '../../layouts/Loading';

import Users from './users/Users';
import User from './users/User';
import UserForm from './users/UserForm';

import Clients from './clients/Clients';
import Client from './clients/Client';
import ClientForm from './clients/ClientForm';

import { useDispatch, useSelector } from 'react-redux';
import Buildings from './buildings/Buildings';
import Building from './buildings/Building';
import BuildingForm from './buildings/BuildingForm';

import Floors from './floors/Floors';
import Floor from './floors/Floor';
import FloorForm from './floors/FloorForm';
import Authorized from '../../layouts/Authorized';
import { useEffect } from 'react';
import RoomList from './floors/rooms/RoomList';
import ConfigsForm from './configs/ConfigsForm';
import ProjectConfig from './projects/ProjectConfig';

const Admin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dark = useSelector((state) => state.dark);
  const { id } = useParams();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (user) {
      if (![1, 2].includes(user.role_id)) {
        navigate('/dashboard');
      }

      console.log("my location path", location.pathname);
      console.log("Test My ID", id)
    }
  }, [user, id]);

  return (
    <div
      className='w-100 dashboard overflow-hidden'
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/images/building${
          dark ? '' : '-Light'
        }.png')`,
      }}
    >
      {user ? (
        <div className='d-flex h-100 position-relative '>
          {/* <IdleTimer logout={logout} /> */}
          {user.role_id === 1 ? (
            <Sidebar
              users={true}
              buildings={true}
              floors={true}
              clients={true}
              configs={true}
              projects={true}
            />
          ) : (
            <Sidebar
              users={true}
              buildings={true}
              floors={true}
              clients={false}
              configs={true}
              projects={true}
            />
          )}

          {location.pathname === '/admin/users' && <Users />}
          {location.pathname === '/admin/users/add' && <UserForm />}
          {location.pathname === '/admin/users/edit' && <UserForm />}

          {location.pathname.includes('/admin/users/userId') && (
            <User id={id} />
          )}
          {location.pathname === '/admin/clients' && (
            <Authorized roles={[1]} Component={Clients} />
          )}
          {location.pathname === '/admin/clients/add' && (
            <Authorized roles={[1]} Component={ClientForm} />
          )}
          {location.pathname === '/admin/clients/edit' && (
            <Authorized roles={[1]} Component={ClientForm} />
          )}

          {location.pathname.includes('/admin/clients/clientId') && (
            <Authorized roles={[1]} Component={Client} id={id} />
          )}

          {location.pathname === '/admin/buildings' && <Buildings />}
          {location.pathname === '/admin/buildings/add' && <BuildingForm />}
          {location.pathname === '/admin/buildings/edit' && <BuildingForm />}
          {location.pathname.includes('/admin/buildings/buildingId') && (
            <Building id={id} />
          )}
          {location.pathname === '/admin/floors' && <Floors />}
          {location.pathname === '/admin/floors/add' && <FloorForm />}
          {location.pathname === '/admin/floors/edit' && <FloorForm />}
          {location.pathname.includes(`/admin/floors/floorId`) && (<Floor id={id} />)}
          {location.pathname.includes('/rooms') && (<RoomList id={id} />)}
          {location.pathname === '/admin/configs' && <ConfigsForm />}

          {/* Projects */}
          {location.pathname === '/admin/projects'&& <ProjectConfig/>}
        </div>
      ) : (
        <div className='d-flex align-items-center h-100 justify-content-center'>
          <Loading />
        </div>
      )}
    </div>
  );
};

export default Admin;
